<template>
    <a @click="onClick" @keydown.enter="onEnterKeyDown">
        <slot></slot>
    </a>
</template>

<script setup lang="ts">
import { ref } from "vue";

const clicked = ref(false);

function onClick(e: Event): void {
    if (clicked.value) {
        e.preventDefault();

        return;
    }

    clicked.value = true;
}

function onEnterKeyDown(e: Event): void {
    onClick(e);
}
</script>
